/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSquareChevronUp = createReactComponent(
  "square-chevron-up",
  "IconSquareChevronUp",
  [
    [
      "path",
      {
        d: "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z",
        key: "svg-0"
      }
    ],
    ["path", { d: "M9 13l3 -3l3 3", key: "svg-1" }]
  ]
);

export { IconSquareChevronUp as default };
//# sourceMappingURL=IconSquareChevronUp.js.map
